module.exports = __webpack_public_path__ + "static/img/2.bb498aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/2.jpg
// module id = dRCe
// module chunks = 1